<template>
  <fn-modal @close="$emit('close')">
    <fn-grid>
      <fn-grid-item
        columns="12"
        columns-m="7"
        static
      >
        <template v-if="media.length === 1">
          <div class="swiper-slide">
            <template v-if="media[0].imageType === 'PRIMARY' || media[0].imageType === 'GALLERY'">
              <fn-picture
                transformation="prod_m"
                :src="media[0].url"
                :alt="media[0].altText || media[0].description"
                :width="1"
                :height="1"
              />
            </template>
            <template v-else>
              <fn-youtube-video :video="media[0].videoId" />
            </template>
          </div>
        </template>
        <template v-else>
          <div
            ref="swiper"
            class="swiper-container"
          >
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in media"
                :key="index"
                class="swiper-slide"
              >
                <fn-sovido
                  v-if="item.type === 'sovido_video'"
                  :product-id="productId"
                />
                <fn-youtube-video
                  v-else-if="item.type === 'video'"
                  :video="item.videoId"
                />
                <fn-picture
                  v-else
                  transformation="prod_m"
                  :src="item.url"
                  :alt="item.altText || item.description"
                  :width="1"
                  :height="1"
                />
              </div>
            </div>
          </div>
        </template>
      </fn-grid-item>
      <fn-grid-item
        columns="12"
        columns-m="4"
        push-m="1"
        static
      >
        <div class="sidebar">
          <slot />

          <div
            v-if="media.length > 1"
            class="thumb-list"
          >
            <div
              v-for="(item, index) in media"
              :key="index"
            >
              <fn-thumb
                v-if="item.type === 'sovido_video'"
                video-thumb-large
                :active="activeIndex === index"
                :src="item.coverImage"
                :width="320"
                :height="180"
                @click="slideTo(index)"
              />
              <fn-thumb
                v-else-if="item.type === 'video'"
                video-thumb
                :active="activeIndex === index"
                :src="`//img.youtube.com/vi/${item.videoId}/mqdefault.jpg`"
                :width="320"
                :height="180"
                @click="slideTo(index)"
              />
              <fn-thumb
                v-else
                :active="activeIndex === index"
                :src="`${item.url}?t=prod_xxs`"
                :width="80"
                :height="80"
                :alt="item.altText || item.description"
                @click="slideTo(index)"
              />
            </div>
          </div>
        </div>
      </fn-grid-item>
    </fn-grid>
  </fn-modal>
</template>

<script>
import SwiperCore from 'swiper/core';

export default {
  props: {
    activeParentIndex: {
      type: Number,
      default: 0,
    },
    media: {
      type: Array,
      default: () => [],
    },
    productId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeIndex: 0,
      swiper: null,
    };
  },
  mounted() {
    this.swiper = new SwiperCore(this.$refs.swiper, {
      on: {
        slideChangeTransitionStart: () => {
          this.activeIndex = this.swiper.realIndex;
        },
      },
    });
    if (this.media.length > 1) {
      this.slideTo(this.activeParentIndex);
    }
  },

  methods: {
    slideTo(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>

<style lang="scss" scoped>
$half-grid-width: math.div($grid-margin-width, 2);

.thumb-list {
  display: flex;
  flex-wrap: wrap;
  margin: $pad * 2 (-($half-grid-width)) (-($half-grid-width));

  .thumb {
    flex: 0 0 auto;
    margin: 0 $half-grid-width $half-grid-width;
  }
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  transition-property: transform;
  box-sizing: content-box;
  transform: translate3d(0, 0, 0);
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
  transform: translate3d(0, 0, 0);

  img {
    display: block;
    width: 520px;
  }
}

.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
}
</style>
